import React from 'react';
import styled from 'styled-components';
import { Row, Col } from 'react-bootstrap';
import color from '../../../../config/color';

const Container = styled.div`
	text-align: center;
`;

const Title = styled.div`
  position: relative;
  font-size: 40px;
  line-height: 1;
  font-weight: 700;
`;

const SubTitle = styled.div`
	font-weight: 700;
	font-size: 24px;
	line-height: 1;
`;

const Detail = styled.div`
	font-size: 20px;
	line-height: 1;
`;

const TextHeader = (props) => {
	return (
		<Container style={props.style}>
			<SubTitle>{props.subTitle}</SubTitle>
			<Title>{props.title} </Title>
			<Detail>{props.detail}</Detail>
		</Container>
	);
};

export default TextHeader;